import styled from '@emotion/styled';
import { ResponsivePicture, IResponsivePictureProps } from '../Image';

export const StyledCardPicture = styled(
	ResponsivePicture,
)<IResponsivePictureProps>`
	flex-shrink: 0;

	img {
		display: block;
		width: 100%;
	}
`;
